import EnquiryContext from 'providers/Enquiry/Enquiry.context';
import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useOpenEnquire() {
  const { onEnquire } = useContext(EnquiryContext);

  const navigate = useNavigate();

  return useCallback(
    (id: string, isTeaserEnabled: boolean, redirectLink?: string) => {
      if (isTeaserEnabled) {
        navigate(`${redirectLink || '.'}/teaser`);
      } else {
        onEnquire(id);
      }
    },
    [navigate, onEnquire],
  );
}
